<template>
  <div id="about" class="font-fira">
    <div class="w-container">
      <div class="w-row">
        <div id="about-top-anchor" ref="about"></div>
        <div class="w-col w-col-2"></div>
        <div class="w-col w-col-8">
          <p
            :key="text"
            class="history-paragraph"
            v-for="text in texts.slice(current * 3, current * 3 + 3)"
          >
            {{ text }}
          </p>
        </div>
      </div>
    </div>
    <div class="w-container">
      <div class="w-row">
        <div class="w-col">
          <div id="controls">
            <font-awesome-icon
              icon="chevron-left"
              class="control"
              v-on:click="prev"
            />
            <div
              class="control-separator"
              :class="{ active: index === current }"
              v-for="(page, index) in pages"
              :key="page"
            ></div>
            <font-awesome-icon
              icon="chevron-right"
              class="control"
              v-on:click="next"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MCAbout",
  data() {
    return {
      texts: [
        this.$t("marinConstantin.about.t1"),
        this.$t("marinConstantin.about.t2"),
        this.$t("marinConstantin.about.t3"),
        this.$t("marinConstantin.about.t4"),
        this.$t("marinConstantin.about.t5"),
        this.$t("marinConstantin.about.t6")
      ],
      pages: 0,
      current: 0
    };
  },
  methods: {
    next: function() {
      this.current += 1;
      this.current %= this.pages;
      // this.moveToTop();
    },
    prev: function() {
      this.current -= 1;
      if (this.current < 0) {
        this.current = this.pages - 1;
      }
      // this.moveToTop();
    },
    moveToTop: function() {
      // var VueScrollTo = require('vue-scrollto');
      // VueScrollTo.scrollTo()
      // this.$scrollTo('#about-top-anchor', 500)
    }
  },
  mounted() {
    this.pages = Math.ceil(this.texts.length / 3);
  }
};
</script>

<style scoped>
#about {
  color: #e2e0e0;
  background-color: #354e61;
  padding: 5vh 0;
}

#controls {
  color: #869bb0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin: 4vh 0;
}

.control {
  border: 1px solid #869bb0;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  padding: 8px;
  vertical-align: middle;
  text-align: center;
  cursor: pointer;
}

.control:hover {
  color: white;
  border: 1px solid white;
}

.control-separator {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  margin: 0 25px;
  position: relative;
  background-color: #869bb0;
}

.control-separator.active {
  background-color: #f5f5f5;
}

.control-separator:before,
.control-separator:after {
  content: "";
  width: 25px;
  height: 2px;
  background-color: #869bb0;
  position: absolute;
  top: calc(50% - 1px);
}

.control-separator:before {
  left: -25px;
}

.control-separator:after {
  right: -25px;
}

.control-separator:first-of-type {
  margin-left: 50px;
}

.control-separator:first-of-type:before {
  width: 50px;
  left: -50px;
}

.control-separator:last-of-type {
  margin-right: 50px;
}

.control-separator:last-of-type:after {
  width: 50px;
  right: -50px;
}

.history-paragraph {
  display: block;
  max-width: 780px;
  margin-right: auto;
  margin-left: auto;
  font-family: "Fira Sans", sans-serif;
  color: #e2e0e0;
  font-size: 1.25em;
  line-height: 26px;
  font-style: normal;
  font-weight: 300;
  margin-bottom: 25px;
}

@media (max-width: 476px) {
  .history-paragraph {
    font-size: 1.1em;
    padding: 0 10px;
  }
}
</style>
